import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { User, ChevronDown } from 'lucide-react';
import { company, teamGroups, teamFaqs } from '../mock';
import { PageFaq } from '../sections/RestSections';

function MemberCard({ m }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`tm-card ${open ? 'open' : ''}`}>
      <div className="tm-photo">
        {m.photo ? <img src={m.photo} alt={m.name} loading="lazy" /> : <span className="tm-ph"><User size={40} strokeWidth={1.3} /></span>}
      </div>
      <div className="tm-body">
        <h4>{m.name}</h4>
        <div className="tm-role">{m.role}</div>
        {m.years ? <div className="tm-years">{m.years} yrs experience</div> : null}
        {m.bio ? (
          <button className="tm-more" onClick={() => setOpen((v) => !v)}>
            {open ? 'Read Less' : 'Read More'} <ChevronDown size={14} />
          </button>
        ) : null}
        {open && <p className="tm-bio">{m.bio}</p>}
      </div>
    </div>
  );
}

export default function TeamPage() {
  return (
    <main className="page team-page">
      <section className="page-hero">
        <div className="wrap">
          <p className="eyebrow">The People Behind the Work</p>
          <h1>Meet Our Team</h1>
          <p className="lede">Our experienced professionals are dedicated to providing exceptional service with a personal touch. Every team member shares our commitment to quality and customer satisfaction.</p>
        </div>
      </section>
      <section className="team-body">
        <div className="wrap">
          {teamGroups.map((g) => (
            <div className="tm-group" key={g.group}>
              <h3 className="tm-group-title">{g.group}</h3>
              <div className="tm-grid">
                {g.members.map((m, i) => <MemberCard key={g.group + i} m={m} />)}
              </div>
            </div>
          ))}
          <div className="tm-join">
            <div>
              <h3>Want to join the team?</h3>
              <p>We&rsquo;re always looking for skilled plumbers and motivated apprentices to grow with Victory Plumbing.</p>
            </div>
            <Link className="btn btn-gold" to="/careers">View Open Positions</Link>
          </div>
        </div>
      </section>
      <PageFaq title="Team &amp; hiring FAQs" subtitle="A little more about the people behind Victory Plumbing." items={teamFaqs} testid="team-faqs" />
    </main>
  );
}
